/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
/* eslint-disable no-case-declarations */
/* eslint-disable no-redeclare */
/* eslint-disable prefer-const */
import {
  AUTO_ALLOCATE_REQUEST,
  AUTO_ALLOCATE_SUCCESS,
  AUTO_ALLOCATE_FAILURE,
  AUTO_UNALLOCATE_REQUEST,
  AUTO_UNALLOCATE_SUCCESS,
  AUTO_UNALLOCATE_FAILURE,
  GET_SERVICES_DETAILS_REQUEST,
  GET_SERVICES_DETAILS_SUCCESS,
  GET_SERVICES_DETAILS_FAILURE,
  AUTO_ALLOCATE_UPDATE_DATES,
  AUTO_ALLOCATE_LOG,
} from '../../../actions/constants/types';
import _ from '../../../utils/lodash';

const autoAllocateModel = (orgUnitId, selectedDate) => ({
  isAllocating: false,
  isUnAllocating: false,
  status: 'Idle',
  progress: 0.0,
  date: selectedDate,
  teamId: 0,
  heartBeat: null,
  createLog: false,
  syncProgress: 0,
  orgUnitId,
});

const initialState = {
  date: null,
  teamId: 0,
  heartBeat: null,
  createLog: false,
  syncProgress: 0,
  autoAllocateInProgress: [],
};

// Check if not exist create Autoallocate request ByUnit
const ensureAutoallocateRequest = (state, orgUnitId, selectedDate) => {
  if (!_.some(state.autoAllocateInProgress, item => item.orgUnitId === orgUnitId && item.date === selectedDate)) {
    state.autoAllocateInProgress.push(autoAllocateModel(orgUnitId, selectedDate));
  }

  return state;
};

let findAutoAllocate = (items, orgUnitId, selectedDate) =>
  _.find(items, item => item.orgUnitId === orgUnitId && item.date === selectedDate);

const createOrUpdateAutoallocate = (state, orgUnitId, selectedDate, params) => {
  state = ensureAutoallocateRequest(state, orgUnitId, selectedDate);

  let model = findAutoAllocate(state.autoAllocateInProgress, orgUnitId, selectedDate);
  if (model && params) {
    for (let i = 0; i < params.length; i++) {
      const propName = Object.keys(params[i])[0];
      const propValue = Object.values(params[i])[0];
      model[propName] = propValue;
    }
  }

  return state;
};

function autoAllocate(state = initialState, action) {
  let params = [];
  switch (action.type) {
    case AUTO_ALLOCATE_REQUEST:
      params = [{ date: action.date }, { status: 'Running' }, { progress: 0.0 }, { isUnAllocating: false }];
      state = createOrUpdateAutoallocate(state, action.orgUnitId, action.date, params);

      return { ...state };
    case AUTO_UNALLOCATE_REQUEST:
      params = [{ date: action.date }, { status: 'Running' }, { isUnAllocating: true }];
      state = createOrUpdateAutoallocate(state, action.orgUnitId, action.date, params);

      return { ...state };
    case AUTO_ALLOCATE_SUCCESS:
    case AUTO_UNALLOCATE_SUCCESS:
      params = [{ status: 'Idle' }, { progress: 0.0 }, { isUnAllocating: false }];
      state = createOrUpdateAutoallocate(state, action.orgUnitId, action.date, params);

      return { ...state };
    case AUTO_ALLOCATE_FAILURE:
    case AUTO_UNALLOCATE_FAILURE:
      params = [{ status: 'Idle' }, { progress: 0.0 }, { isUnAllocating: false }];
      state = createOrUpdateAutoallocate(state, action.orgUnitId, action.date, params);

      return { ...state };
    case GET_SERVICES_DETAILS_REQUEST:
      return {
        ...state,
      };
    case GET_SERVICES_DETAILS_SUCCESS:
      const orgUnitId = action.response.data.autoAllocationDetails.teamId;
      const selectedDate = action.response.data.autoAllocationDetails.dateForWhichAutoAllocationIsRan;
      params = [
        { progress: parseInt(action.response.data.autoAllocationDetails.progress * 100, 10) },
        { syncProgress: parseInt(action.response.data.synchronizationDetails.SynchronizationProgress, 10) },
      ];
      state = createOrUpdateAutoallocate(state, orgUnitId, selectedDate, params);

      return {
        ...state,
        ...action.response.data.autoAllocationDetails,
        ...action.response.data.synchronizationDetails,
      };
    case GET_SERVICES_DETAILS_FAILURE:
      return {
        ...state,
      };
    case AUTO_ALLOCATE_LOG:
      return {
        ...state,
        createLog: action.createLog,
      };
    case AUTO_ALLOCATE_UPDATE_DATES:
      params = [{ date: action.data.date }];
      state = createOrUpdateAutoallocate(state, action.data.orgUnitId, action.data.date, params);
      return { ...state };

    // return { ...state, date: action.data.date, teamId: action.data.teamId };
    default:
      return state;
  }
}

export default autoAllocate;
